//
// class FrontendFormValidationService {
//     constructor(state, isError, setIsError, rules) {
//         this.state = state;
//         this.isError = isError;
//         this.setIsError = setIsError;
//         this.rules = rules;
//     }
//     validate () {
//         console.log(this.state);
//         let isValid = true;
//         for (const rulesKey in this.rules) {
//             console.log(rulesKey);
//             // eslint-disable-next-line no-loop-func
//             this.rules[rulesKey].forEach(rulesKeyword => {
//                 switch (rulesKeyword) {
//                 case "notEmpty":
//                     if (this.isEmpty(rulesKey)) {
//                         return true;
//                     } else {
//                         isValid = false;
//                         break;
//                     }
//                 case "earlierThan":
//                     return true;
//                 default: return true;
//                 }
//                 console.log(isValid);
//             });
//         }
//         return isValid;
//     }
//     isEmpty (key, message) {
//         if (this.state[key]) {
//             return true;
//         } else {
//             this.setIsError(prev => {
//                 return {
//                     ...prev,
//                     [key]: message ? message : "Поле не должно быть пустым",
//                 };
//             });
//             return false;
//         }
//     }
//     earlierThan (key, compareKey) {
//         return true;
//     }
// }
//
// export default FrontendFormValidationService;
class FrontendFormValidationService {
    constructor(state, isError, setIsError, rules) {
        this.state = state;
        this.isError = isError;
        this.setIsError = setIsError;
        this.rules = rules;
    }

    validate() {
        console.log("Validating with state:", this.state);
        console.log("Rules:", this.rules);

        let isValid = true;
        const newErrors = {};

        // Проверяем только те поля, которые есть в rules
        for (const fieldName in this.rules) {
            console.log("Checking field:", fieldName);

            this.rules[fieldName].forEach(rule => {
                console.log(`Rule for ${fieldName}:`, rule);

                switch (rule) {
                    case "notEmpty":
                        if (!this.isEmpty(fieldName)) {
                            isValid = false;
                            newErrors[fieldName] = "Поле не должно быть пустым";
                        }
                        break;
                    case "earlierThan":
                        if (!this.earlierThan(fieldName)) {
                            isValid = false;
                            newErrors[fieldName] = "Дата должна быть раньше";
                        }
                        break;
                    default:
                        console.log("Unknown rule:", rule);
                }
            });
        }

        // Устанавливаем все ошибки разом
        if (Object.keys(newErrors).length > 0) {
            this.setIsError(prev => ({
                ...prev,
                ...newErrors,
            }));
        }

        console.log("Validation result:", isValid);
        return isValid;
    }

    isEmpty(key) {
        const value = this.state[key];
        console.log(`Checking if ${key} is empty:`, value);

        // Если поля нет в rules, не проверяем его
        if (!this.rules[key]) {
            return true;
        }

        // Проверяем, пустое ли значение
        const isEmpty = !value || (typeof value === "string" && value.trim() === "");
        console.log(`Is ${key} empty?`, isEmpty);

        return !isEmpty;
    }

    earlierThan(key, compareKey) {
        // Логика для проверки "раньше чем"
        return true;
    }
}

export default FrontendFormValidationService;
